export default __webpack_public_path__ + "static/media/ArrowLeft.b0d7af05.svg";